import { redirect } from "@tanstack/react-router";
import { getSnapshot } from "@/features/auth/authStore";

export function requireAuth({ location }: { location: { href: string } }) {
  const state = getSnapshot();
  const isExpired = !state || state.expiredAt <= Math.floor(Date.now() / 1000);

  if (isExpired) {
    throw redirect({
      to: "/login",
      search: { redirect: location.href },
    });
  }
}
